'use client'
import styles from './SearchText.module.scss'
import SVGSearch from '@/src/components/common/SVG/SVGSearch'
import { ChangeEvent, MouseEventHandler } from 'react'
import SVGClose from '@/src/components/common/SVG/SVGClose'

export default function SearchTextClient({
  placeholder = 'Search',
  ..._
}: {
  placeholder?: string
  value?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onClear?: MouseEventHandler<SVGSVGElement>
}) {
  return (
    <label className={styles.container}>
      <SVGSearch />
      <input type={'text'} placeholder={placeholder} value={_.value} onChange={_.onChange} />
      <SVGClose width={12} className={styles.clear} onClick={_.onClear} />
    </label>
  )
}
